// CarmaHttp and CarmaActiveX Interfaces

// var mode_encrypt = 12;
var mode_sign = 14;
var mode_verify = 15;
// var mode_setcert = 21;
// var mode_getcertinfo = 22;
// var mode_translatecrl = 23;
var mode_testconn = 24;
// var mode_iskeyvalid = 25;
// var mode_encryptmulty = 26;
var mode_sign2 = 27;
// var mode_cosign = 28;
var mode_getsigninfo = 29;
var mode_showsign = 30;
// var mode_streamencode = 31;
var mode_streammultyenc = 32;
var mode_streamdecode = 33;
var mode_getcertinfo2 = 34;
// var mode_getcert = 35;
var mode_enumstore = 37;
var mode_enumcert = 38;
var mode_showcert = 39;
// var mode_translatecrl2 = 40;
var mode_getreceplist = 41;
// var mode_initcrysvc = 42;
// var mode_stopcrysvc = 43;
// var mode_getsigntype = 44;
var mode_setcert2 = 45;
// var mode_setcertpk = 46;
var mode_CreateHash = 50;
var mode_SignRaw = 51;
// var mode_VerifyRaw = 52;
var mode_streamsign = 53;
// var mode_streamverify = 54;
var mode_streamsigninfo = 55;
var mode_signhash = 56;
var mode_getsigninfo2 = 57;
var mode_SignHashRaw = 58;
var mode_streamshowsign = 59;
// var mode_import = 60;
// var mode_releaseClient = 61;
// var mode_setCrl = 62;
var mode_streamhash = 63;
// var mode_streamcosign = 64;
// var mode_parsecert = 65;
// var mode_parsecrl = 66;

var mode_streamgetsigninfo2 = 69;

function NotImplementedError(methodName) {
    return new TypeError("Метод " + methodName + " не реализован.");
}

function CarmaConnectionInterface(params) {
    var self = this;

    if (params != null) {
        console.log("CarmaConnectionInterface Factory call");

        if (params.cryptoActiveX == "" || params.cryptoActiveX == "EosUtils.EosCryptoSvc") {
            return new CarmaHttp(params.cryptoInitStr, params.stores);
        }
    }
    console.log("CarmaConnectionInterface:ctor()");

    self.ConnectionName = "CarmaConnectionInterface";
    self.stores = [];
    self.Initialized = false;
    self.TestConnection = function () {
        throw NotImplementedError("TestConnection");
    }

    // Unused params (content, certId)
    self.Sign = function () {
        throw NotImplementedError("Sign");
    }

    // Unused params (content, certId, comment, isAttached, certInclude, addSigner, uri)
    self.Sign2 = function () {
        throw NotImplementedError("Sign2");
    }

    // Unused params (content, certId, comment, isAttached, certInclude, addSigner, uri)
    self.SignHash = function () {
        throw NotImplementedError("SignHash");
    }

    // Unused params (content, certId)
    self.SignRaw = function () {
        throw NotImplementedError("SignRaw");
    }

    // Unused params (content, certId)
    self.SignHashRaw = function () {
        throw NotImplementedError("SignHashRaw");
    }

    // Unused params (content, certId, alg)
    self.Hash = function () {
        throw NotImplementedError("Hash");
    }

    // Unused params (content, signature)
    self.GetSignInfo = function () {
        throw NotImplementedError("GetSignInfo");
    }

    // Unused params (certId)
    self.GetCertInfo = function () {
        throw NotImplementedError("GetCertInfo");
    }

    // Unused params (content, signature)
    self.ShowSign = function () {
        throw NotImplementedError("ShowSign");
    }

    // Unused params (certId)
    self.ShowCert = function () {
        throw NotImplementedError("ShowCert");
    }

    // Unused params (certId)
    self.ValidateCert = function () {
        throw NotImplementedError("ValidateCert");
    }

    // Unused params (location, address, name)
    self.EnumCertificates = function () {
        throw NotImplementedError("EnumCertificates");
    }

    // Unused params (location, address)
    self.EnumStores = function () {
        throw NotImplementedError("EnumStores");
    }

    // Unused params (stores)
    self.EnumAllCertificates = function () {
        throw NotImplementedError("EnumAllCertificates");
    }

    // Unused params (certId, stores)
    self.FindStoreByCertID = function () {
        throw NotImplementedError("FindStoreByCertID");
    }

    // Unused params (initStr)
    self.PreloadKey = function () {
        throw NotImplementedError("PreloadKey");
    }

    // Unused params (location, address, name)
    self.SetCurrentStore = function () {
        throw NotImplementedError("SetCurrentStore");
    }

    self.PKIAvailable = false;
    self.CryptoAvailable = false;
    self.SignHashMethodAvailable = true;

    self.ErrorEmptySignData = "Отсутствуют данные для подписания.";

    //для совместимости с датой, возвращаемой activeX
    function convertDateStr(str) {
        // var match = str.match(/^(\d+).(\d+).(\d+) (\d+)\:(\d+)\:(\d+)$/); // Original
        var match = str.match(/^(\d+).(\d+).(\d+) (\d+):(\d+):(\d+)$/); // ":" не является спец. символом и поэтому его не надо экранировать, оставил оригинал на всякий случай, мало ли чего не допонял 
        //если время обрезано
        if (!match) {
            match = str.match(/^(\d+).(\d+).(\d+)$/);
            match.push("00", "00", "00");
        }
        var date = new Date(match[3], match[2] - 1, match[1], match[4], match[5], match[6]);
        return date;
    }

    self._convertCertDate = function (cert) {
        if (cert.ValidFrom) {
            cert.ValidFrom = convertDateStr(cert.ValidFrom);
        }
        if (cert.ValidTo) {
            cert.ValidTo = convertDateStr(cert.ValidTo);
        }
        if (cert.ValidFromUTC) {
            cert.ValidFromUTC = convertDateStr(cert.ValidFromUTC);
        }
        if (cert.ValidToUTC) {
            cert.ValidToUTC = convertDateStr(cert.ValidToUTC);
        }
        if (cert.IssuerCert != null) {
            self._convertCertDate(cert.IssuerCert);
        }
    }

    self._convertSignDate = function (sign) {
        sign.SignTime = convertDateStr(sign.SignTime);
        if (sign.SignTimeUTC) {
            sign.SignTimeUTC = convertDateStr(sign.SignTimeUTC);
        }
        self._convertCertDate(sign.SignCert);
    }
}

export function CarmaHttp(initStr, stores, callback) {
    console.log('CarmaHttp:ctor("' + initStr + '" , ' + JSON.stringify(stores) + ')');
    CarmaConnectionInterface.call(this);


    var self = this;

    self.PKIAvailable = true;//dummy for http
    self.CryptoAvailable = true;//dummy for http
    self.ServiceInfo = { carmaVersion: "0", carmaProtocolVersion: "0", defaultModule: "" };
    self.ModuleName = "";

    self.url = 'http://localhost:8080';
    self.serverAddress = self.url;
    self.initStr = '';
    self.useHttp = true;

    self.stores = stores;
    self.initStr = initStr;
    self.ConnectionName = "CarmaHttp";

    self.isWork = true;

    var storesConfig;
    var ctorStores = stores;

    {
        var index = initStr.toUpperCase().indexOf('SERVER=');
        if (index != -1) {
            var s = initStr.substring(index + 7);
            var end = s.indexOf(';');
            var val = '';
            if (end == -1)
                end = s.length;

            val = s.substring(1, end - 1);//параметр SERVER имеет формат значения с кавычками

            self.url = val;
            self.serverAddress = val;
			
            var tokens = val.split('/');
            if (tokens.length > 0) {
                if (tokens[0] == 'http:' || tokens[0] == 'https:') {
                    self.useHttp = true;
                    if (tokens.length > 3) {
                        tokens.length = 3;
                        self.serverAddress = tokens.join('/');
                    }
                } else {
                    self.useHttp = false;
                    if (tokens[0] == 'pipe:' && tokens.length > 4) {
                        tokens.length = 4;
                        self.serverAddress = tokens.join('/');
                    }
                }
            }
        }
    }



    self.__make_stores = function (stores) {
        var res = [];
        for (var i = 0; i < stores.length; i++) {
            var location = stores[i].Location;
            var address = stores[i].Address;
            var name = stores[i].Name;

            if (location == '')
                location = 'sscu';
            if (name == '')
                name = 'MY';

            res.push({ location: location, address: address, name: name });
        }
        return res;
    }

    //self.__make_stores(stores);

    function createRequestObject() {
        if (typeof XMLHttpRequest === 'undefined') {
             return new Error("Браузер не поддерживает XMLHttpRequest.");
        }
        return new XMLHttpRequest();
    }

    //запрос без jquery для переносимости скрипта
    self.request = function (obj, onDone, async) {
        if(self.isWork){
           if (obj.currentStores == null) {
               if (storesConfig == null || ctorStores != self.stores) {
                   storesConfig = self.__make_stores(self.stores);
                   ctorStores = self.stores;
               }
               obj.currentStores = storesConfig;
           }
           
           if (obj.fileData != null && obj.fileDataEncodedSize == null)
               obj.fileDataEncodedSize = obj.fileData.length;
           
           
           obj.extInitParams = self.initStr;
           
           var data = JSON.stringify(obj);
           var errorMsg;
           var xmlhttp = createRequestObject();
           xmlhttp.onreadystatechange = function () {
               if (xmlhttp.readyState == 4) {
                   if (xmlhttp.status == 200) {
                       var jsonObj = JSON.parse(xmlhttp.responseText);
           
                       if (jsonObj.errorCode != 0) {
                           //throw new Error(jsonObj.errormessage);//вызывается необработанное исключение
                           errorMsg = jsonObj.errorMessage;
                       }
           
                       if (onDone != null) {
                           onDone(jsonObj);
                       }
                   } else {
                       self.isWork=false;
                       throw new Error("Не удалось получить данные (" + xmlhttp.status + ").");
                   }
               }
           };

           xmlhttp.open('POST', self.url, async);
           xmlhttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
           xmlhttp.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
           xmlhttp.setRequestHeader('Accept-Language', 'ru-RU, ru;q=0.8,en-US;q=0.6, en;q=0.4');
           
           try {
               xmlhttp.send(data);
           } catch (e) {
               self.isWork=false;
               var netError = "NetworkError";
               var message = e.message;
               if (message == null || message.length == 0) {
                   message = netError;
               }
               throw new Error(((message.slice(0, netError.length) == netError) || message == "error") ? "Ошибка подключения к серверу КАРМА (" + self.url + "). Дополнительная информация: " + message + "(" + e.name + ")" : message);
           }
           
           if (errorMsg) {
               throw new Error(errorMsg);
           }
        }

    }

    function getServiceInfo() {
        if (self.useHttp) {
            var errorMsg;
            var xmlhttp = createRequestObject();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) {
                        self.ServiceInfo = JSON.parse(xmlhttp.responseText);
                    } else {
                        errorMsg = "Не удалось получить сведения о сервисе КАРМА (" + xmlhttp.status + ").";
                    }
                }
            };

            xmlhttp.open('GET', self.serverAddress, false);
            xmlhttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xmlhttp.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
            xmlhttp.setRequestHeader('Accept-Language', 'ru-RU, ru;q=0.8,en-US;q=0.6, en;q=0.4');

            try {
                xmlhttp.send("t");
            } catch (e) {
                var netError = "NetworkError";
                var message = e.message;
                if (message == null || message.length == 0) {
                    message = netError;
                }
                throw new Error(((message.slice(0, netError.length) == netError) || message == "error") ? "Ошибка подключения к серверу КАРМА (" + self.url + "). Дополнительная информация: " + message + "(" + e.name + ")" : message);
            }

            if (errorMsg) {
                throw new Error(errorMsg);
            }
        }
    }

    function getCurrentModuleName() {
        var index = initStr.indexOf('MODULE=');
        if (index != -1) {
            var s = initStr.substring(index + 7);
            var end = s.indexOf(';');
            var val = '';
            if (end == -1)
                end = s.length;
            val = s.substring(1, end - 1);

            self.ModuleName = val.toLowerCase();
        }
        else {
            self.ModuleName = self.ServiceInfo.defaultModule;
        }

    }

    self.TestConnection = function () {
        self.request({
            mode: mode_testconn
        }, afterTest, true);
    }

    self.TestConnection();

    function afterTest() {
        try {
            getServiceInfo();
            getCurrentModuleName();
            
            {
                self.SignHashMethodAvailable = true;
                try {
                    // var ret = '';
            
                    self.request({
                        mode: mode_signhash,
                        certInclude: 0,
                        isAttached: true,
                        senderCertId: "",
                        fileData: "",
                        comment: "",
                        test: true,
                        uri: ""
                    }, function (data) {
                        self.SignHashMethodAvailable = (data.errorCode == 0);
            
                    }, false); 
                }
                catch (e) {
                    self.SignHashMethodAvailable = false;
                }
            
            }
            callback();
        } catch (e) {
            console.log(e)
        }
    }

    self.Sign = function (content, certId) {
        console.log('CarmaHttp.Sign');

        var ret = '';

        self.request({
            mode: mode_sign,
            senderCertId: certId,
            certInclude: 2,
            fileData: content,
        }, function (data) {
            ret = data.fileData;
        }, false);

        return ret;
    }

    self.Sign2 = function (content, certId, comment, isAttached, certInclude, addSigner, uri) {
        console.log('CarmaHttp.Sign2');

        if (content == null || content.length == 0) {
            throw new Error(self.ErrorEmptySignData);
        }

        var ret = '';

        self.request({
            mode: mode_sign2,
            certInclude: certInclude,
            isAttached: isAttached == 0 ? false : true,
            senderCertId: certId,
            fileData: content,
            comment: comment,
            uri: uri
        }, function (data) {
            ret = data.fileData;
        }, false);

        return ret;
    }

    self.SignHash = function (content, certId, comment, isAttached, certInclude, addSigner, uri) {
        console.log('CarmaHttp.SignHash');

        if (content == null || content.length == 0) {
            throw new Error(self.ErrorEmptySignData);
        }

        var ret = '';

        self.request({
            mode: mode_signhash,
            certInclude: certInclude,
            isAttached: isAttached == 0 ? false : true,
            senderCertId: certId,
            fileData: content,
            comment: comment,
            uri: uri
        }, function (data) {
            ret = data.fileData;
        }, false);

        return ret;
    }
    self.SignRaw = function (content, certId) {
        console.log('CarmaHttp.SignRaw');
        var ret = '';

        self.request({
            mode: mode_SignRaw,
            isAttached: false,
            senderCertId: certId,
            fileData: content,
        }, function (data) {
            ret = data.fileData;
        }, false);

        return ret;
    }
    self.SignHashRaw = function (content, certId) {
        console.log('CarmaHttp.SignHashRaw');
        var ret = '';

        self.request({
            mode: mode_SignHashRaw,
            isAttached: false,
            senderCertId: certId,
            fileData: content,
        }, function (data) {
            ret = data.fileData;
        }, false);

        return ret;
    }

    self.Hash = function (content, certId, alg) {
        console.log('CarmaHttp.Hash');
        var ret = '';
        var requestObj = {
            mode: mode_CreateHash,
            fileData: content,
        };
        if (certId == null || certId == "") {
            requestObj["hashAlg"] = alg;

        }
        else {
            requestObj["senderCertId"] = certId;
        }
        self.request(requestObj, function (data) {
            ret = data.fileData;
        }, false);

        return ret;
    }

    self.GetSignInfo = function (content, signature) {
        console.log('CarmaHttp.GetSignInfo');

        var attached = signature == null || signature == "" || signature.toLowerCase() == "attached";

        var ret = null;
        self.request({
            mode: mode_getsigninfo,
            isAttached: attached,
            sendSignData: signature,
            fileData: content
        }, function (data) {
            ret = data.signInfo;
        }, false);

        if (ret != null) {
            for (var i = 0; i < ret.length; i++) {
                self._convertSignDate(ret[i]);
            }
        }

        return ret;
    }

    self.GetSignInfoFromUrl = function (contentUrl, signature) {
        console.log('CarmaHttp.GetSignInfoFromUrl');

        var attached = signature == null || signature == "" || signature.toLowerCase() == "attached";

        var ret = null;
        self.request({
            mode: mode_getsigninfo,
            isAttached: attached,
            sendSignData: signature,
            fileDataUrl: contentUrl
        }, function (data) {
            ret = data.signInfo;
        }, false);

        if (ret != null) {
            for (var i = 0; i < ret.length; i++) {
                self._convertSignDate(ret[i]);
            }
        }

        return ret;
    }

    self.GetSignInfoStream = function (signature, fileStream) {
        console.log('CarmaHttp.GetSignInfoStream');

        var streamId = 0;
        var ret = null;

        var attached = signature == null || signature == "" || signature.toLowerCase() == "attached";

        do {
            var content = fileStream.getNextChunk();

            self.request({
                mode: mode_streamsigninfo,
                isAttached: attached,
                fileData: content,
                sendSignData: signature,
                streamFinalChunk: fileStream.isFinalChunk,
                streamId: streamId
            }, function (packet) {
                if (fileStream.isFinalChunk)
                    ret = packet.signInfo;

                streamId = packet.streamId;
            }, false);
        }
        while (!fileStream.isFinalChunk)

        if (ret != null) {
            for (var i = 0; i < ret.length; i++) {
                self._convertSignDate(ret[i]);
            }
        }

        return ret;
    }

    self.GetSignInfo2Stream = function (signatures, fileStream) {
        console.log('CarmaHttp.GetSignInf2oStream');

        var chunk = 0;
        var streamId = 0;
        var final = false;
        var ret = null;

        var attached = false;

        do {
            var content = fileStream.getChunk(chunk);

            if (content.length == 0)
                final = true;

            self.request({
                mode: mode_streamgetsigninfo2,
                isAttached: attached,
                fileData: content,
                signatures: signatures,
                streamFinalChunk: final,
                streamId: streamId
            }, function (packet) {
                if (final)
                    ret = packet.signInfoArray;

                streamId = packet.streamId;
            }, false);

            chunk++;
        }
        while (!final)

        if (ret != null) {
            for (var i = 0; i < ret.length; i++) {
                for (var sign in ret[i])
                    self._convertSignDate(ret[i][sign]);
            }
        }

        return ret;
    }


    self.GetSignInfo2 = function (content, signatures) {
        console.log('CarmaHttp.GetSignInfo2');

        var attached = false;// signatures == null || signature == "" || signature.toLowerCase() == "attached";

        var ret = null;
        self.request({
            mode: mode_getsigninfo2,
            isAttached: attached,
            signatures: signatures,
            fileData: content
        }, function (data) {
            ret = data.signInfoArray;
        }, false);

        if (ret != null) {
            for (var i = 0; i < ret.length; i++) {
                for (var sign in ret[i])
                    self._convertSignDate(ret[i][sign]);
            }
        }

        return ret;
    }

    self.ShowSignStream = function (signature, fileStream) {
        console.log('CarmaHttp.ShowSignStream');

        var streamId = 0;

        var attached = signature == null || signature == "" || signature.toLowerCase() == "attached";

        do {
            var content = fileStream.getNextChunk();

            self.request({
                mode: mode_streamshowsign,
                isAttached: attached,
                fileData: content,
                sendSignData: signature,
                streamFinalChunk: fileStream.isFinalChunk,
                streamId: streamId
            }, function (packet) {
                streamId = packet.streamId;
            }, false);
        }
        while (!fileStream.isFinalChunk)
    }

    self.SignStream = function (signature, fileStream, certId, comment, isAttached, certInclude, addSigner, uri) {
        console.log('CarmaHttp.SignStream');

        var streamId = 0;
        var ret = null;

       // var attached = signature == null || signature == "" || signature.toLowerCase() == "attached";

        do {
            var content = fileStream.getNextChunk();

            self.request({
                mode: mode_streamsign,
                certInclude: certInclude,
                isAttached: isAttached == 0 ? false : true,
                senderCertId: certId,
                fileData: content,
                comment: comment,
                uri: uri,
                sendSignData: signature,
                streamFinalChunk: fileStream.isFinalChunk,
                streamId: streamId
            }, function (packet) {
                if (fileStream.isFinalChunk)
                    ret = packet.fileData;

                streamId = packet.streamId;
            }, false);

        }
        while (!fileStream.isFinalChunk)

        return ret;
    }

    self.HashStream = function (fileStream, certId, alg) {
        console.log('CarmaHttp.HashStream');

        var streamId = 0;
        var ret = null;

        var requestObj = {
            mode: mode_streamhash
        };
        if (certId == null || certId == "") {
            requestObj["hashAlg"] = alg;

        }
        else {
            requestObj["senderCertId"] = certId;
        }

        do {
            var content = fileStream.getNextChunk();
            requestObj["fileData"] = content;
            requestObj["streamFinalChunk"] = fileStream.isFinalChunk;
            requestObj["streamId"] = streamId;

            self.request(requestObj, function (packet) {
                if (fileStream.isFinalChunk)
                    ret = packet.fileData;

                streamId = packet.streamId;
            }, false);

        }
        while (!fileStream.isFinalChunk)

        return ret;
    }

    self.GetCertInfo = function (certId) {
        console.log('CarmaHttp.GetCertInfo2');

        var ret = null;

        self.request({
            mode: mode_getcertinfo2,
            senderCertId: certId,
            needExtraction: true
        }, function (data) {
            ret = data.certInfo;
        }, false);

        if (ret != null) {
            self._convertCertDate(ret);
        }
        return ret;
    }

    self.ShowSign = function (content, signature) {
        console.log('CarmaHttp.ShowSign');

        self.request({
            mode: mode_showsign,
            isAttached: false,
            sendSignData: signature,
            fileData: content
        }, function () {
        }, true);
    }

    self.ShowSignFromUrl = function (contentUrl, signature) {
        console.log('CarmaHttp.ShowSignFromUrl');

        self.request({
            mode: mode_showsign,
            isAttached: false,
            sendSignData: signature,
            fileDataUrl: contentUrl
        }, function () {
        }, true);
    }

    self.ShowCert = function (certId) {
        console.log('CarmaHttp.ShowCert');

        self.request({
            mode: mode_showcert,
            senderCertId: certId
        }, function () {
        }, true);
    }

    self.ValidateCert = function (certId) {
        console.log('CarmaHttp.ValidateCert');

        var str_valid = "VALID";
        var str_invalid = "INVALID ";
        var cert_info = self.GetCertInfo(certId);
        var validity = cert_info.Validity;
        var has_pkey = cert_info.HasPrivateKey;

        var is_valid = validity.indexOf(str_valid) == 0;
        var why_invalid = is_valid
                            ? ""
                            : validity.substring(str_invalid.length);
        return {
            HasPKey: has_pkey == true,
            IsValid: is_valid,
            Reason: why_invalid
        };
    }

    self.EnumCertificates = function (location, address, name) {
        console.log('CarmaHttp.EnumCertificates');

        var ret = null;

        if (location == '')
            location = 'sscu';
        if (name == '')
            name = 'MY';

        self.request({
            mode: mode_enumcert,
            storeAddress:
                {
                    location: location,
                    address: address,
                    name: name
                }
        }, function (data) {
            ret = data.certificates;
        }, false);

        return ret;
    }

    self.EnumStores = function (location, address) {
        console.log('CarmaHttp.EnumStores');

        var ret = null;

        if (location == '')
            location = 'sscu';

        self.request({
            mode: mode_enumstore,
            storeAddress:
                {
                    location: location,
                    address: address,
                    name: ''
                }
        }, function (data) {
            ret = data.stores;
        }, false);

        return ret;
    }

    self.EnumAllCertificates = function (stores) {
        var result = [];
        for (var i = 0; i < stores.length; i++) {
            var dict = null;
            try {
                dict = this.EnumCertificates(stores[i].Location, stores[i].Address, stores[i].Name);
            } catch (e) {
                dict = null;
                throw e;
            }

            if (dict) {
                for (var j = 0; j < dict.length; j++)
                    result.push(dict[j]);
            }
        }

        return result;
    }

    self.FindStoreByCertID = function (certId, stores) {
        console.log('CarmaHttp.FindStoreByCertID');

        var ex = null;
        for (var si = 0; si < stores.length; si++) {
            var store = stores[si];
            try {
                var certs = self.EnumCertificates(store.Location, store.Address, store.Name);
                var cnt = certs.length;
                for (var ci = 0; ci < cnt; ci++)
                    if (certId == certs[ci])
                        return store;
            }
            catch (e) {
                ex = ex || e;
            }
        }
        throw ex || {
            message: "NEED", certId: certId
        };
    }

    // Unused params (initStr)
    self.PreloadKey = function () {
        console.log('CarmaHttp.PreloadKey_Dummy');
        //nothing to do there
    }

    // Unused params (location, address, name)
    self.SetCurrentStore = function () {
        console.log('CarmaHttp.SetCurrentStore_Dummy');
        //nothing to do theree
    }

    self.SetCurrentStores = function (stores) {
        console.log('CarmaHttp.SetCurrentStores');

        storesConfig = null;
        this.stores = stores;
    }

    self.EncryptMulty = function (content, senderCertId, recipientCertIds) {
        var ret = null;
        self.request({
            mode: mode_streammultyenc,
            senderCertId: senderCertId,
            recipientCertId: recipientCertIds.join(';'),
            fileDataEncodedSize: content.length,
            fileData: content,
            streamFinalChunk: true
        }, function (packet) {
            ret = packet.fileData;
        }, false);

        return ret;
    }

    self.Decrypt = function (encodedContent, recipientCertId) {
        var ret = null;
        self.request({
            mode: mode_streamdecode,
            recipientCertId: recipientCertId,
            fileDataEncodedSize: encodedContent.length,
            fileData: encodedContent,
            streamFinalChunk: true
           // streamId: self.streamId
        }, function (packet) {
            ret = packet.fileData || '';
            //self.streamId = packet.streamId;
        }, false);

        return ret;
    }


	self.Verify =  function (content, signature) {
		var ret = null;
        self.request({
			mode: mode_verify,
			fileData: content,
			isAttached: false,
			sendSignData: signature,
			needExtraction: true
		}, function (data) {
			ret = data;
        }, false);
		
		return ret;
	}

	self.SetCert = function (certContent) {
		var ret = null;
		self.request({
            mode: mode_setcert2,
			fileData: certContent,
			fileDataEncodedSize: certContent.length
        }, function (data) {
			ret = data.certInfos[0];
        }, false);

        if (ret != null) {
            self._convertCertDate(ret);
        }

        return ret;
	}

    self.GetRecipientsList = function (encodedContent)
    {
        var ret = [];
        self.request({
            // mode: mode_getreciplist, // Была опечатка? Подставил другое значение из списка модов
            mode: mode_getreceplist,
            fileData: encodedContent,
        }, function (data) {
            ret = data.certificates;
        }, false);

        return ret;
    }

    self.Initialized = true;
}
